import './publication.css'
import React from 'react'

function Volume24no12() {
  return (
    <div className="p-2">
      <section className='content-header d-flex flex-column justify-content-start'>
        <h3 className="p-2" >Vol. 24, Nos. 1&2, Mar/Jun 2023</h3>
        <h5 className="p-2">CONTENTS</h5>
            <div className="p-2 contents">
             <a href= '/volume-24-no1&2/Iyoha,O.&M.Alugbin-PragmaticExpressionofStanceinNigerianNewspapers.pdf'><p> Pragmatic Expression of Stance in Nigerian Newspaper Reports on Pro-Biafra Protests - 
 <strong>Osas Iyoha & Matthew Alugbin</strong> - 1 </p> </a> 
              </div>
              <div className="p-2">
            <a href= '/volume-24-no1&2/Ogbedeto,C.C.-LiteraryDiscourseofWolrdontheBrinks.pdf'><p>A Literary Discourse Study of World on the Brinks, an Anthology of Poems on the 
 COVID- 19 Pandemic - 
 <strong> Chimeziri Charity Ogbedeto</strong> - 16 </p></a> 
              </div>
              <div className="p-2">
              <a href= '/volume-24-no1&2/Okonkwo,G.K.-TheAbjectionsoftheNewMan.pdf'><p> The Abjections of the New Man in Femi Ademiluyi's The New Man - 
 <strong> Gabriel Kosiso Okonkwo</strong> - 29 </p></a>
              </div>
              <div className="p-2">
              <a href= '/volume-24-no1&2/Olodude,I.I.-ConstituentandSentenceNegationinIkaleDialect.pdf'> <p> Constituent and Sentence Negation in the Ìkálẹ̀ Dialect of Yorùbá - 
 <strong> Ibukunolu Isaac Olodude</strong> - 43 </p></a>
              </div>
              <div className="p-2">
              <a href= '/volume-24-no1&2/Onanuga,A.-WomenOppressorsandMaleQueerVictims.pdf'><p> Women Oppressors and Male Queer Victims: An Analysis of Selected Fictional 
Narratives on Homosexuality - 
 <strong> Ayobami Olajumoke Onanuga</strong> - 63 </p></a>
              </div>
              <div className="p-2">
             <a href='/volume-24-no1&2/Oruyei,O.-TenseinEnglishandIzon.pdf'> <p> A Contrastive Analysis of Tense in English and Ịzọn - 
 <strong> Oki Oruyei</strong> - 80 </p> </a>
              </div>              
            <hr/>
            
        </section>
    </div>
  )
}
export default Volume24no12;

